import { useEffect } from "react";

type Props = {
  letter: string;
  onTrigger: () => void;
  enabled: boolean;
};

const isMac = /Mac|iPod|iPhone|iPad/.test(navigator.platform);
export const shortcutModifierLabel = isMac ? "Cmd" : "Ctrl";

export function useQuickAccessShortcut({ letter, onTrigger, enabled }: Props) {
  useEffect(() => {
    if (!enabled) return;

    function onKeyDown(event: KeyboardEvent) {
      const primaryModifier = isMac ? event.metaKey : event.ctrlKey;
      if (!primaryModifier || !event.shiftKey) return;
      if (event.code !== `Key${letter.toUpperCase()}`) return;

      const target = event.target as HTMLElement | null;
      if (target && (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable)) {
        return;
      }

      event.preventDefault();
      onTrigger();
    }

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [letter, onTrigger, enabled]);
}
